<template>
  <div class="api-block test-mode msdk">
    <div>
      <h2 class="api-h1">MSDK</h2>
    </div>
    <p class="api-description">
      {{ $t('msdk_1') }}</p>
    <p class="api-description">
      {{ $t('msdk_2') }}
    </p>
    
    <p class="api-description">
     {{ $t('msdk_3') }}
    </p>
    <ul class="api-list" v-if="links">
      <li>IOS:  <a href="https://gitlab.onevision.kz/msdk/msdk-ios-library">https://gitlab.onevision.kz/msdk/msdk-ios-library
      </a>
      </li>
      <li>Android: <a href="https://gitlab.onevision.kz/msdk/msdk-view-demo-app">https://gitlab.onevision.kz/msdk/msdk-view-demo-app</a>
        <a href="https://gitlab.onevision.kz/msdk/msdk-compose-demo-app">https://gitlab.onevision.kz/msdk/msdk-compose-demo-app</a></li>
    </ul>

    <ul class="api-list" v-if="linksPaysage">
      <li>IOS:  <a href="https://gitlab.onevision.kz/msdk/msdk-ios-library/-/tree/feature_paysage?ref_type=heads">https://gitlab.onevision.kz/msdk/msdk-ios-library/-/tree/feature_paysage?ref_type=heads
      </a>
      </li>
      <li>Android: <a href="https://gitlab.onevision.kz/msdk/msdk-compose-demo-app/-/tree/paysage?ref_type=heads">https://gitlab.onevision.kz/msdk/msdk-compose-demo-app/-/tree/paysage?ref_type=heads</a>
        <a href="https://gitlab.onevision.kz/msdk/msdk-view-demo-app/-/tree/paysage?ref_type=heads">https://gitlab.onevision.kz/msdk/msdk-view-demo-app/-/tree/paysage?ref_type=heads</a></li>
    </ul>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue';
export default {
  props: {
    company_info: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(){
    const links = ref(false);

    const linksPaysage = ref(false);

    onMounted(() => {
      if(window.location.hostname.includes('onevision')){
        links.value = true;
      }else if(window.location.hostname.includes('paysage')){
        linksPaysage.value = true;
      }
    })

    return{
      links,
      linksPaysage
    }
  }
};
</script>

<style lang="scss">
.test-mode {
  border-top: 0.8px solid rgb(115, 115, 115);
  .api-h1 {
    padding-bottom: 20px !important;
  }
}

.bt-grey {
  border-top: 1px solid gainsboro;
  padding-top: 20px !important;
  margin-top: 20px !important;
}

.msdk{
  .api-list{
    li{
      & + li{
        margin-top: 16px;
      }
      a{
        font-size: 16px;
        color: #19226d;
        font-weight: 600;
        display: block;
      }
    }
  }
}
</style>
